import { useMemo } from 'react'
import { capitalize } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data
    return data.map(status => ({
      id: status.id,
      text: capitalize(status.text),
    }))
  }, [])
}
